import React from 'react';
import classes from './BrowserAppHelp.module.scss';
import { isChrome, isFirefox, isOpera, isEdge } from 'react-device-detect';

import ChromeAppHelp from './ChromeAppHelp';
import FirefoxAppHelp from './FirefoxAppHelp';
import OperaAppHelp from './OperaAppHelp';
import EdgeAppHelp from './EdgeAppHelp';

export interface Props {}

const BrowserAppHelp: React.FC<Props> = () => {
  if (isChrome) {
    return (
      <div className={classes.tutorial}>
        <ChromeAppHelp />
      </div>
    );
  }
  if (isFirefox) {
    return (
      <div className={classes.tutorial}>
        <FirefoxAppHelp />
      </div>
    );
  }
  if (isOpera) {
    return (
      <div className={classes.tutorial}>
        <OperaAppHelp />
      </div>
    );
  }
  if (isEdge) {
    return (
      <div className={classes.tutorial}>
        <EdgeAppHelp />
      </div>
    );
  }
  return (
    <div className={classes.root}>
      The browser app is currently only available on Chrome, Firefox, Opera and Edge.
    </div>
  );
};

export default BrowserAppHelp;
